import type { IconType } from 'react-icons';
import {
  RiAlertLine,
  RiArchiveLine,
  RiBuilding2Line,
  RiChat3Line,
  RiFileList3Line,
  RiFileTextLine,
  RiFlag2Line,
  RiGlobalLine,
  RiLightbulbLine,
  RiLinksLine,
  RiMailLine,
  RiMapPinLine,
  RiPhoneLine,
  RiQuestionLine,
  RiServerLine,
  RiUserStarLine,
  RiWallet3Line,
} from 'react-icons/ri';

/** 实体/线索类型 → 图标（统一来源，画布外一律使用 react-icons）。 */
export const ENTITY_ICONS: Record<string, IconType> = {
  person: RiUserStarLine,
  people: RiUserStarLine,
  organization: RiBuilding2Line,
  org: RiBuilding2Line,
  email: RiMailLine,
  phone: RiPhoneLine,
  domain: RiGlobalLine,
  ip: RiServerLine,
  social: RiChat3Line,
  wallet: RiWallet3Line,
  location: RiMapPinLine,
  nameserver: RiServerLine,
  document: RiFileTextLine,
  evidence: RiArchiveLine,
  hypothesis: RiLightbulbLine,
  relation: RiLinksLine,
  flag: RiFlag2Line,
};

export function entityIcon(type: string): IconType {
  return ENTITY_ICONS[type] ?? RiQuestionLine;
}

/** 实体类型的中文名称。 */
const TYPE_LABELS: Record<string, string> = {
  person: '个人',
  people: '个人',
  organization: '组织',
  org: '组织',
  email: '邮箱',
  phone: '电话',
  domain: '域名',
  ip: 'IP 地址',
  social: '社交账号',
  wallet: '加密钱包',
  location: '位置',
  nameserver: '名称服务器',
  document: '文档',
  evidence: '证据',
  hypothesis: '研判',
};

export function labelForType(type: string): string {
  return TYPE_LABELS[type] ?? type;
}

export const ENTITY_ICON_LIST: { type: string; label: string }[] = [
  { type: 'person', label: '个人' },
  { type: 'organization', label: '组织' },
  { type: 'email', label: '邮箱' },
  { type: 'phone', label: '电话' },
  { type: 'domain', label: '域名' },
  { type: 'ip', label: 'IP' },
  { type: 'social', label: '社交账号' },
  { type: 'wallet', label: '钱包' },
  { type: 'location', label: '位置' },
  { type: 'document', label: '文档' },
];

/** 风险等级的颜色类。 */
export const RISK_TEXT: Record<string, string> = {
  unknown: 'text-muted-foreground',
  low: 'text-emerald-700',
  medium: 'text-amber-700',
  high: 'text-orange-700',
  critical: 'text-[var(--color-cord)]',
};

export const RISK_BG: Record<string, string> = {
  unknown: 'bg-muted text-muted-foreground',
  low: 'bg-emerald-50 text-emerald-700',
  medium: 'bg-amber-50 text-amber-700',
  high: 'bg-orange-50 text-orange-700',
  critical: 'bg-red-50 text-[var(--color-cord)]',
};

export const RISK_LABEL: Record<string, string> = {
  unknown: '未评估',
  low: '低',
  medium: '中',
  high: '高',
  critical: '极高',
};

export const SEVERITY_BG: Record<string, string> = {
  low: 'bg-emerald-50 text-emerald-700',
  medium: 'bg-amber-50 text-amber-700',
  high: 'bg-orange-50 text-orange-700',
  critical: 'bg-red-50 text-[var(--color-cord)]',
};

export const SEVERITY_LABEL: Record<string, string> = {
  low: '低',
  medium: '中',
  high: '高',
  critical: '严重',
};

export const ASSESS_STATUS_LABEL: Record<string, string> = {
  open: '待验证',
  supported: '已支持',
  refuted: '已排除',
};

export const RELIABILITY_LABEL: Record<string, string> = {
  A: 'A · 完全可靠',
  B: 'B · 通常可靠',
  C: 'C · 较可靠',
  D: 'D · 不可靠',
  E: 'E · 无法判断',
  F: 'F · 无法评估',
};

export { RiAlertLine, RiArchiveLine, RiLightbulbLine, RiLinksLine, RiFlag2Line };